export default __webpack_public_path__ + "static/media/ans2.5fdfa60f.png";